import { Card, Tag, Space, Avatar } from 'antd';
import { PhoneOutlined, EnvironmentOutlined, EyeOutlined } from '@ant-design/icons';
import s from './index.module.css';
import React from "react";

const InstitutionCard = ({ institution, onClick }) => {
  // const { id, name, types, phone, address, views, logo } = institution;
  const { name, telephone: phone, officeAddress, regAddress, seeNum: views, checkLogoUrl, orgLabelList = [] } = institution;
  const labels = (Array.isArray(orgLabelList) ? orgLabelList : []).filter(Boolean);
  const hasMoreLabels = labels.length > 2;
  const labelsToShow = hasMoreLabels ? labels.slice(0, 2) : labels;

  return (
    <Card
      className={s.institutionCard}
      hoverable
      bodyStyle={{ padding: '16px' }}
      onClick={() => onClick && onClick(institution)}
    >
      <div className={s.institutionContent}>
        {/* 机构标题 */}
        <div className={s.institutionHeader}>
          <div className={s.institutionIcon}>
            {/*<BuildOutlined/>*/}
            <div className={s.logoBox}>
              <div className={s.orgLogo}>
                {
                  checkLogoUrl ? (
                      <img
                          src={checkLogoUrl}
                          alt="logo.png"/>
                  ) : (
                      <Avatar size={48} style={{ background: 'var(--color-primary)' }}>
                        {name && name[0]}
                      </Avatar>
                  )
                }
              </div>
            </div>
          </div>
          <h4 className={s.institutionName}>{name}</h4>
        </div>

        {/* 检测类型标签 */}
        <div className={s.institutionTypes}>
          <Space size={[4, 4]} wrap>
            {labelsToShow.map((type, index) => (
              <Tag key={`${type}-${index}`} color="blue" className={s.typeTag}>
                {type}
              </Tag>
            ))}
            {hasMoreLabels && (
              <Tag key="ellipsis" className={`${s.typeTag} ${s.typeTagEllipsis}`}>
                ...
              </Tag>
            )}
          </Space>
        </div>

        {/* 联系信息 */}
        <div className={s.institutionInfo}>
          <div className={s.infoItem}>
            <PhoneOutlined className={s.infoIcon}/>
            <span className={s.infoText}>{phone}</span>
          </div>
          <div className={s.infoItem}>
            <EnvironmentOutlined className={s.infoIcon}/>
            <span className={s.infoText}>{regAddress || officeAddress || '--'}</span>
          </div>
        </div>

        {/* 浏览量 */}
        <div className={s.institutionStats}>
          <div className={s.statItem}>
            <EyeOutlined className={s.statIcon} />
            <span className={s.statText}>浏览：{views}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default InstitutionCard;
